import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import keycloak from "./keycloak";
import { getAuthTokens } from "./auth/authTokens";

const apiConfig = window.__ENV__ || {};

const httpLink = new HttpLink({
  uri: apiConfig.GRAPHQL_HTTP_URL || "",
});

// Injecte le token Keycloak (rafraîchi par keycloak-js) ; fallback sur le cookie.
const authLink = setContext((_, { headers }) => {
  const token = keycloak.token || getAuthTokens().token;

  if (!token || token === "undefined") {
    console.warn("No token, GraphQL request will be sent without authorization header");
    return { headers: { ...headers } };
  }

  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default apolloClient;
